import moment from 'moment-timezone';
import store from '../../store/store'

const momentUtcToUserTz = (val) => {
	const localTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
	const userTimeZone = store.getState().user.user.settings.time_zone || localTZ;

	if (!val) {
		return "";
	}

	return moment.utc(val).tz(userTimeZone);
};

export default momentUtcToUserTz
